module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "make-a-difference-card"
  }, [_c('div', {
    staticClass: "display-progress-numbers"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('DisplayProgressBar', {
    attrs: {
      "percentage": _vm.percentage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "quantity"
  }, [_c('div', [_vm._v(_vm._s(_vm.signedUpQuantity))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.sigupMessage))])]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "quantity"
  }, [_c('div', [_vm._v(_vm._s(_vm.neededToReach))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.goalMessage) + " " + _vm._s(_vm.getPetitionGoal))])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "separator"
  }, [_c('div', {
    staticClass: "bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54411eec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/display-progress-numbers/DisplayProgressNumbers.vue
// module id = 810
// module chunks = 0